// Material UI
import { makeStyles } from '@material-ui/styles'
// Consts
import Colors from '../../../../../constants/Colors'

export default makeStyles(theme => ({
  root: {
    backgroundColor: Colors.GRANNY_APPLE,
    color: Colors.MALACHITE,
  },
}))
